export default __webpack_public_path__ + "static/media/san-usa.91b326b9.jpg";